export default __webpack_public_path__ + "static/media/nibiruSymbol.b34c08df.svg";